import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import store from "../store";

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "active",
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  // console.log(store.state.Auth.user);
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters["Auth/IsAuthenticate"]) {
      next({
        path: "/login",
        params: { nextUrl: to.fullPath }
      });
    } else {
      // if (to.matched.some(record => record.meta.IsAdmin)) {
      //   if (store.getters["Auth/IsAdmin"]) {
      //     next();
      //   } else {
      //     next({ path: "/" });
      //   }
      // } else if (to.matched.some(record => record.meta.IsUser)) {
      //   if (store.getters["Auth/IsUser"]) {
      //     next();
      //   } else {
      //     next({ path: "/" });
      //   }
      // } else if (to.matched.some(record => record.meta.IsActive)) {
      //   if (store.getters["Auth/IsActive"]) {
      //     next();
      //   } else {
      //     next({ path: "/login" });
      //   }
      // } else {
      //   next();
      // }

        next();
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    next();
  } else {
    next();
  }
});

export default router;
